<template>
  <div class="contenido">
    <h2 class="pl-3">{{ father }} | Promover Alumnos</h2>
    <v-dialog v-model="dialog" content-class="reporte">
      <v-card>
        <v-card-title class="grey lighten-4 py-4 title">Promover Alumnos</v-card-title>
      </v-card>
    </v-dialog>
    <template v-if="cargandoDatos" justify="center">
      <v-row justify="center" class="text-center">
        <v-col cols="12">
          <v-progress-circular :size="50" indeterminate color="purple"></v-progress-circular>
        </v-col>
      </v-row>
    </template>
    <template v-else-if="!cargandoDatos && alumnos.length < 1">
      <v-row justify="center" class="text-center">
        <v-col cols="12">
          <h3>No hay alumnos para promover.</h3>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row no-gutters>
        <v-col class="text-right">
          <v-btn color="success" @click="dialog=!dialog">Promover Alumnos</v-btn>
        </v-col>
      </v-row>
      <div class="pa-3 ma-3">
        <v-row align-end no-gutters>
          <v-col cols="5" class="header">Alumno</v-col>
          <v-col cols="1" class="header text-center">Dni</v-col>
          <v-col cols="2" class="header text-center">Curso Origen</v-col>
          <v-col cols="1" class="header a">a</v-col>
          <v-col cols="2" class="header text-center">Curso Destino</v-col>
        </v-row>
        <template v-for="alumno in alumnos">
          <v-row :key="alumno.idalumno">
            <v-col cols="5" class="borde_inferior">{{alumno.nombre}}</v-col>
            <v-col cols="1" class="borde_inferior text-center">{{alumno.dni}}</v-col>
            <v-col cols="2" class="borde_inferior text-center">{{alumno.curso_origen}}</v-col>
            <v-col cols="1" class="borde_inferior text-center">
              <!--<span class="material-icons">mdi-forward</span>-->
              <v-icon>mdi-forward</v-icon>
            </v-col>
            <v-col cols="2" class="borde_inferior text-center">{{alumno.curso_destino}}</v-col>
          </v-row>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import API from "@/components/_config/conf";

export default {
  data: () => ({
    dialog: false,
    cargandoDatos: true,
    alumnos: []
  }),
  props: ["father"],
  mounted: function() {
    let params = "";
    let resultado = API.enviar("get", "obtenerAlumnosAPromover", params);
    resultado
      .then(result => {
        if (result.data.msj == "ok") {
          this.alumnos = result.data.result;
          this.cargandoDatos = false;
        }
      })
      .catch(error => {
        console.log(
          "promoverAlumno | methods | obtenerAlumnosAPromover |  catch: -> ",
          error
        );
      });
  }
};
</script>

<style scoped>
.contenido {
  width: 100% !important;
}

.header {
  margin-top: 30px;
  padding: 10px 0;
  font-size: 13px;
  font-weight: bold;
  padding-left: 5px;
  background-color: #ccc;
  opacity: 0.8;
}

.a {
  color: #ccc;
}

.borde_inferior {
  border-bottom: solid 1px #000;
}
</style>